import Model from "./base/model";

class quoteProposal extends Model{
  resourceName() {
    return "quote_proposals";
  }

  fields() {
    return {
      path: "",
      name: "",
      checked: "",
      updated_at: "",
      monthly_interest: "",
      annual_interest: "",
      installment_value: "",
      installments: "",
    }
  }
}

export default new quoteProposal();
